import { HeadingOneSmall, HeadingThreeSmall, HeadingTwoSmall } from '@wix/wix-ui-icons-common';

import { HEADER_BLOCK } from './../ricos-content';
import type { EditorPluginCreator, KeyboardShortcut } from './../ricos-types';
import { createShortcut, Node_Type, quickActionsModalSections } from './../ricos-types';

import { DEFAULTS } from './defaults';
import { getTextButtons } from './getTextButtons';
import type { HeadingsPluginEditorConfig } from './types';
import { HEADINGS_DROPDOWN_TYPE } from './types';

const headerBlockByLevel = [
  HEADER_BLOCK.ONE,
  HEADER_BLOCK.TWO,
  HEADER_BLOCK.THREE,
  HEADER_BLOCK.FOUR,
  HEADER_BLOCK.FIVE,
  HEADER_BLOCK.SIX,
];

const getShortcut = (level: 1 | 2 | 3 | 4 | 5 | 6): KeyboardShortcut =>
  createShortcut({
    name: `${Node_Type.HEADING}.${level}`,
    description: `ShortcutsSheet_Formatting_Heading${level}`,
    keys: { macOs: `Meta+Alt+${level}`, windows: `Ctrl+Alt+${level}` },
    command({ publicCommands }) {
      publicCommands.setBlockType(headerBlockByLevel[level - 1]);
    },
    group: 'ShortcutsSheet_Section_Formatting',
    enabled: true,
  });

export const pluginHeadings: EditorPluginCreator<HeadingsPluginEditorConfig> = config => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: HEADINGS_DROPDOWN_TYPE,
    tiptapExtensions: [],
    shortcuts: ([1, 2, 3, 4, 5, 6] as const).map(getShortcut),
    textButtons: getTextButtons(config),
    getQuickActions: ({ config }) => [
      ...(config?.customHeadings?.includes('H1')
        ? [
            {
              id: 'headingOne',
              title: 'QuickActionsPlugin_ActionTitle_HeadingOne',
              icon: HeadingOneSmall,
              section: quickActionsModalSections.FormatLayout,
              tags: [
                'title',
                'header',
                'section title',
                'main heading',
                'h1',
                'top level heading',
                'large text',
              ],
              command: ({ publicCommands }: $TSFixMe) =>
                publicCommands.setBlockType(HEADER_BLOCK.ONE),
            },
          ]
        : []),
      ...(config?.customHeadings?.includes('H2')
        ? [
            {
              id: 'headingTwo',
              title: 'QuickActionsPlugin_ActionTitle_HeadingTwo',
              icon: HeadingTwoSmall,
              section: quickActionsModalSections.FormatLayout,
              tags: ['subheading', 'h2', 'medium heading', 'section heading'],
              command: ({ publicCommands }: $TSFixMe) =>
                publicCommands.setBlockType(HEADER_BLOCK.TWO),
            },
          ]
        : []),
      ...(config?.customHeadings?.includes('H3')
        ? [
            {
              id: 'headingThree',
              title: 'QuickActionsPlugin_ActionTitle_HeadingThree',
              icon: HeadingThreeSmall,
              section: quickActionsModalSections.FormatLayout,
              tags: [
                'h3',
                'small heading',
                'section subheading',
                'sub-subheading',
                'subsection heading',
              ],
              command: ({ publicCommands }: $TSFixMe) =>
                publicCommands.setBlockType(HEADER_BLOCK.THREE),
            },
          ]
        : []),
    ],
  };
};
